import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from 'semantic-ui-react';
import _ from 'lodash';
import memoizeOne from 'memoize-one';
import * as commentActions from '../../../actions/commentActions';
import CommentBox from './comment-box/CommentBox';
import AddComment from './addComent/AddComment';
import { ReactComponent as NoCommentIcon } from '../../../icons/comment.svg';
import styles from './TaskComments.module.css';

const COMMENT_FORM_INITIAL_VALUE = { comment: '', attachments: [] };

class Comments extends React.Component {
  sortComments = memoizeOne((comments) => {
    const clonedComments = [...comments];
    return clonedComments.sort(
      (comment1, comment2) => new Date(comment1.createdOn).getTime() - new Date(comment2.createdOn).getTime()
    );
  });

  constructor(props) {
    super();
    const {
      task: { id: taskId },
      fieldId,
    } = props;
    this.state = {
      commentFormInitialValue: { ..._.cloneDeep(COMMENT_FORM_INITIAL_VALUE), taskId, fieldId },
    };
  }

  async componentDidMount() {
    const {
      task: { id: taskId },
      actions,
    } = this.props;
    if (taskId) {
      actions.getCommentsByTaskId(taskId);
      actions.setTaskIdForComments(taskId);
    } else {
      actions.setNullComments();
    }
  }

  componentWillUnmount() {
    this.props.actions.setTaskIdForComments(null);
  }

  onAddButtonClicked = async (values, formik) => {
    try {
      await this.props.actions.upsertComment(values);
      this.resetCommentFormWithBlankedValues();
      formik.resetForm();
    } catch (e) {
      console.error(e);
    }
  };

  onUpdateButtonClickedInCommentBox = (comment) => {
    this.setState({
      commentFormInitialValue: _.pick(_.cloneDeep(comment), ['id', 'comment', 'attachments']),
    });
  };

  resetCommentFormWithBlankedValues = () => {
    const {
      task: { id: taskId },
      fieldId,
    } = this.props;
    this.setState({
      commentFormInitialValue: { ..._.cloneDeep(COMMENT_FORM_INITIAL_VALUE), taskId, fieldId },
    });
  };

  onCancelButtonClicked = () => {
    this.resetCommentFormWithBlankedValues();
  };

  validateForm = (values) => {
    const errors = {};
    if (!values.comment || values.comment.trim().length === 0) {
      errors.comment = 'Comment is Required';
    }
    return errors;
  };

  render() {
    const { commentFormInitialValue } = this.state;
    const sortedComments = this.sortComments(this.props.comments);
    return (
      <Grid padded style={{ height: '100%', flexDirection: 'column', flexWrap: 'nowrap' }}>
        <Grid.Row columns={1} style={{ flex: '1 1 200px', minHeight: '0px', flexDirection: 'column' }}>
          <Grid.Column style={{ flex: '0 0 auto', fontSize: '14px', fontFamily: 'JoynFontMedium', paddingLeft: '0px' }}>
            Comments
          </Grid.Column>
          <Grid.Column
            style={{ flex: '1 1 150px', borderRadius: '4px', overflowY: 'auto', flexGrow: '1', padding: '0px' }}
          >
            {/* eslint-disable-next-line no-nested-ternary */}
            {this.props.isCommentsLoading ? (
              <div className="joyn2-loader" />
            ) : this.props.comments && this.props.comments.length === 0 ? (
              <NoCommentsComponent />
            ) : (
              sortedComments.map((comment) => (
                <CommentBox
                  onUpdateButtonClicked={this.onUpdateButtonClickedInCommentBox}
                  key={comment.id}
                  comment={comment}
                />
              ))
            )}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={1} style={{ flex: '0 0 auto' }}>
          <AddComment
            validateForm={this.validateForm}
            onAddButtonClicked={this.onAddButtonClicked}
            addCommentLoading={this.props.addCommentLoading}
            commentFormInitialValue={commentFormInitialValue}
            onCancelButtonClicked={this.onCancelButtonClicked}
          />
        </Grid.Row>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    fieldId: state.appReducer.selectedField.id,
    comments: state.commentReducer.comments,
    isCommentsLoading: state.commentReducer.isLoading,
    addCommentLoading: state.commentReducer.addCommentLoading,
  };
}

function mapActionsToProps(dispatch) {
  return {
    actions: bindActionCreators(commentActions, dispatch),
  };
}

export default connect(mapStateToProps, mapActionsToProps)(Comments);

const NoCommentsComponent = React.memo(function NoCommentsComponent() {
  return (
    <div className={styles.noCommentContainer}>
      <div>No Comments found</div>
      <div>
        <NoCommentIcon />
      </div>
      <div>Be the first one to add a comment.</div>
    </div>
  );
});
